import * as actionTypes from '../actionTypes/membership';

// Action to start fetching user info (loading state)
export function getOdMembership() {
  return { type: actionTypes.GET_MEMBERSHIP };
}

// Action when fetching is successful
export function getOdMembershipSuccess(membership) {
  return { type: actionTypes.GET_MEMBERSHIP_SUCCESS, payload: membership };
}

// Action when fetching fails
export function getOdMembershipError(error) {
  return { type: actionTypes.GET_MEMBERSHIP_ERROR, payload: error };
}
